import { deleteTenantUser } from '@infuse/api/iam/tenant';
import { useGenericDeleteUser } from '@infuse/iam/user/mutations';

export const useDeleteTenantUser = () =>
  useGenericDeleteUser({
    apiFn: deleteTenantUser
  });
